var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{staticClass:"blank-page",attrs:{"breadCrumb":_vm.breadCrumb}},[_vm._v(" 欢迎来到兔兔出国 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }